import {SelectOption} from "../../components/form/types";

export type RegistrationFormData = {
  salutation: SelectOption | null;
  company: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  mobile?: string | null;
  uid: string | null;
  website?: string | null;
};

export const defaultRegistrationFormData = {
  salutation: { value: 'female', label: 'Frau' },
  company: null,
  firstName: null,
  lastName: null,
  email: null,
  phone: null,
  mobile: null,
  uid: null,
  website: null
};